module.exports = __webpack_public_path__ + "img/marina.d8f05b30.png";